import React from 'react';
import { PaginationProvider } from './pagination';

const AppProviders = ({ children }) => (
  <PaginationProvider>{children}</PaginationProvider>
);

export default AppProviders;
